<template>
  <div class="contact-page">
    <section class="page-hero">
      <img src="/img/hero-project-inspection.webp" alt="江苏道鼎升对公工程查验项目咨询联系方式" />
      <div class="page-hero-mask"></div>
      <div class="page-hero-content">
        <nav class="breadcrumb" aria-label="面包屑">
          <router-link to="/">首页</router-link>
          <span>/</span>
          <span>联系我们</span>
        </nav>
        <p class="eyebrow">Project Consultation</p>
        <h1>联系我们，获取对公项目查验与工程质量检测方案</h1>
        <p>
          面向开发商、建设单位、物业单位、建筑企业和住宅交付项目，支持精装入场查验、过程质量巡检、分户查验、一房一验、交付前预验收、工程质量检测和整改复查等服务咨询。个人业主验房请进入独立页面预约。
        </p>
      </div>
    </section>

    <section class="section">
      <div class="section-inner contact-layout">
        <div class="contact-info">
          <p class="eyebrow">Contact Information</p>
          <h2>项目咨询信息</h2>
          <p>请优先提供项目城市、项目类型、预计户数、交付时间和服务需求，我们会基于这些信息沟通人员安排、进场计划和报价口径。</p>
          <div class="info-list">
            <div class="info-item">
              <i class="el-icon-phone"></i>
              <div>
                <strong>电话咨询</strong>
                <span>{{ company.phone }}</span>
              </div>
            </div>
            <div class="info-item">
              <i class="el-icon-message"></i>
              <div>
                <strong>邮箱联系</strong>
                <span>{{ company.email }}</span>
              </div>
            </div>
            <div class="info-item">
              <i class="el-icon-location-outline"></i>
              <div>
                <strong>公司地址</strong>
                <span>{{ company.address }}</span>
              </div>
            </div>
          </div>
          <div class="wechat-card">
            <img src="/img/wechat_qrcode.jpg" alt="江苏道鼎升微信联系二维码" />
            <div>
              <strong>微信联系</strong>
              <span>扫码添加微信客服，便于发送项目信息与查验需求。</span>
            </div>
          </div>
        </div>

        <el-form class="contact-form" ref="contactForm" :model="form" :rules="rules" label-width="132px">
          <h2>提交项目需求</h2>
          <el-form-item label="公司名称" prop="companyName">
            <el-input v-model="form.companyName" placeholder="请输入公司名称"></el-input>
          </el-form-item>
          <el-form-item label="项目名称" prop="projectName">
            <el-input v-model="form.projectName" placeholder="请输入项目名称"></el-input>
          </el-form-item>
          <el-form-item label="项目城市" prop="city">
            <el-input v-model="form.city" placeholder="如：苏州、南京、上海"></el-input>
          </el-form-item>
          <el-form-item label="项目类型" prop="projectType">
            <el-select v-model="form.projectType" placeholder="请选择项目类型">
              <el-option v-for="item in projectTypes" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="预计查验户数" prop="households">
            <el-input v-model="form.households" placeholder="如：500 户"></el-input>
          </el-form-item>
          <el-form-item label="预计交付时间" prop="deliveryTime">
            <el-input v-model="form.deliveryTime" placeholder="如：2026年10月"></el-input>
          </el-form-item>
          <el-form-item label="需要的服务" prop="serviceNeed">
            <el-checkbox-group v-model="form.serviceNeed">
              <el-checkbox v-for="item in serviceNeeds" :key="item" :label="item"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="联系人" prop="contactName">
            <el-input v-model="form.contactName" placeholder="请输入联系人"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="微信号" prop="wechat">
            <el-input v-model="form.wechat" placeholder="请输入微信号"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input
              v-model="form.remark"
              type="textarea"
              :rows="4"
              placeholder="可补充楼栋范围、交付批次、报告要求等"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="submit-btn" @click="submitForm">提交需求</el-button>
            <el-button @click="resetForm">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </section>

    <section class="section muted">
      <div class="section-inner">
        <div class="section-heading">
          <p class="eyebrow">Before Contact</p>
          <h2>咨询前建议准备的信息</h2>
          <p>信息越完整，越容易快速判断项目所需人员配置、服务周期和报告交付方式。</p>
        </div>
        <div class="prepare-grid">
          <div v-for="item in prepareItems" :key="item.title" class="prepare-card">
            <i :class="item.icon"></i>
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <section class="section cta-section">
      <div class="section-inner cta-inner">
        <div>
          <h2>也可以先查看服务内容</h2>
          <p>如果暂时还不确定服务范围，可以先从对公服务页了解精装入场查验、过程巡检、分户查验和整改复查的差异。</p>
        </div>
        <router-link class="btn" to="/services">查看对公服务</router-link>
      </div>
    </section>

    <div class="beian">
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">苏ICP备2024065706号</a>
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32050602013590" target="_blank" rel="noopener">苏公网安备32050602013590号</a>
    </div>
  </div>
</template>

<script>
import { companyInfo } from "../data/services";
import {
  absoluteUrl,
  breadcrumbSchema,
  localBusinessSchema,
  organizationSchema,
  setSeo,
  setStructuredData
} from "../utils/seo";

export default {
  name: "Download",
  data() {
    return {
      company: companyInfo,
      projectTypes: ["毛坯", "精装", "商业", "公寓", "别墅", "其他"],
      serviceNeeds: ["精装入场查验", "过程质量巡检", "分户查验 / 一房一验", "交付前预验收", "整改复查", "工程质量检测", "报告输出", "其他"],
      form: {
        companyName: "",
        projectName: "",
        city: "",
        projectType: "",
        households: "",
        deliveryTime: "",
        serviceNeed: [],
        contactName: "",
        phone: "",
        wechat: "",
        remark: ""
      },
      rules: {
        companyName: [{ required: true, message: "请输入公司名称", trigger: "blur" }],
        projectName: [{ required: true, message: "请输入项目名称", trigger: "blur" }],
        city: [{ required: true, message: "请输入项目城市", trigger: "blur" }],
        projectType: [{ required: true, message: "请选择项目类型", trigger: "change" }],
        serviceNeed: [{ type: "array", required: true, message: "请选择需要的服务", trigger: "change" }],
        contactName: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号码", trigger: "blur" }
        ]
      },
      prepareItems: [
        {
          icon: "el-icon-office-building",
          title: "项目基础信息",
          desc: "项目名称、所在城市、项目类型、楼栋范围和预计查验户数。"
        },
        {
          icon: "el-icon-date",
          title: "交付与进场节点",
          desc: "预计交付时间、开放日安排、施工整改窗口和可进场时间。"
        },
        {
          icon: "el-icon-document",
          title: "报告交付要求",
          desc: "是否需要分户报告、汇总报告、照片记录、问题分类或整改复查记录。"
        },
        {
          icon: "el-icon-s-operation",
          title: "服务范围偏好",
          desc: "确认需要查验、实测实量、陪验、复查、报告或其他专项服务。"
        }
      ]
    };
  },
  mounted() {
    setSeo({
      title: "联系江苏道鼎升工程检测有限公司｜获取对公项目查验方案",
      description:
        "联系江苏道鼎升工程检测有限公司，获取精装入场查验、过程质量巡检、分户查验、一房一验、交付前预验收、工程质量检测和整改复查项目方案。",
      path: "/download",
      image: "/img/hero-project-inspection.webp"
    });
    setStructuredData([
      organizationSchema(),
      localBusinessSchema(),
      {
        "@type": "ContactPage",
        name: "联系我们",
        url: absoluteUrl("/download"),
        description: "江苏道鼎升工程检测有限公司项目查验与工程质量检测服务咨询页面。"
      },
      breadcrumbSchema([
        { name: "首页", path: "/" },
        { name: "联系我们", path: "/download" }
      ])
    ]);
  },
  methods: {
    submitForm() {
      this.$refs.contactForm.validate(valid => {
        if (!valid) {
          return;
        }
        this.$message({
          message: "已收到您的项目查验需求，我们会尽快与您联系。",
          type: "success"
        });
        this.resetForm();
      });
    },
    resetForm() {
      this.$refs.contactForm.resetFields();
    }
  }
};
</script>

<style lang="scss" scoped>
.contact-page {
  background: #f5f8f7;
  color: #1f2d3d;
}

.page-hero {
  min-height: 430px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.page-hero img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.page-hero-mask {
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(12, 38, 51, 0.92), rgba(15, 76, 92, 0.68));
}

.page-hero-content,
.section-inner {
  width: min(1180px, calc(100% - 48px));
  margin: 0 auto;
}

.page-hero-content {
  position: relative;
  z-index: 1;
  color: #fff;
}

.breadcrumb {
  display: flex;
  gap: 8px;
  margin-bottom: 26px;
  color: rgba(255, 255, 255, 0.78);
}

.breadcrumb a {
  color: rgba(255, 255, 255, 0.92);
  text-decoration: none;
}

.eyebrow {
  color: #d76b30;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 12px;
}

.page-hero h1 {
  max-width: 880px;
  font-size: 42px;
  line-height: 1.25;
  margin: 0 0 18px;
}

.page-hero p {
  max-width: 900px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 17px;
  line-height: 1.9;
}

.section {
  padding: 72px 0;
}

.muted {
  background: #fff;
}

.contact-layout {
  display: grid;
  grid-template-columns: 0.86fr 1.14fr;
  gap: 36px;
  align-items: start;
}

h2 {
  color: #0f4c5c;
  font-size: 31px;
  line-height: 1.35;
  margin: 0 0 14px;
}

.contact-info p,
.section-heading p,
.prepare-card p,
.cta-section p {
  color: #5c6873;
  line-height: 1.8;
}

.info-list {
  display: grid;
  gap: 14px;
  margin-top: 24px;
}

.info-item,
.wechat-card,
.contact-form,
.prepare-card {
  border: 1px solid #dce6e4;
  border-radius: 8px;
  background: #fff;
}

.info-item,
.wechat-card {
  display: flex;
  gap: 14px;
  align-items: center;
  padding: 18px;
}

.info-item i {
  color: #d76b30;
  font-size: 25px;
}

.info-item strong,
.wechat-card strong {
  display: block;
  color: #17313b;
  margin-bottom: 5px;
}

.info-item span,
.wechat-card span {
  color: #5c6873;
  line-height: 1.7;
}

.wechat-card {
  margin-top: 14px;
}

.wechat-card img {
  width: 112px;
  height: 112px;
  object-fit: cover;
  border-radius: 4px;
}

.contact-form {
  padding: 30px;
}

.contact-form h2 {
  margin-bottom: 24px;
}

.contact-form .el-select {
  width: 100%;
}

.submit-btn {
  background: #18736e;
  border-color: #18736e;
}

.section-heading {
  max-width: 780px;
  margin-bottom: 30px;
}

.prepare-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}

.prepare-card {
  padding: 24px;
}

.prepare-card i {
  color: #d76b30;
  font-size: 28px;
}

.prepare-card h3 {
  color: #17313b;
  margin: 16px 0 10px;
}

.cta-section {
  background: #0f4c5c;
}

.cta-inner {
  display: flex;
  justify-content: space-between;
  gap: 24px;
  align-items: center;
}

.cta-inner h2,
.cta-inner p {
  color: #fff;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 0 22px;
  border-radius: 4px;
  background: #d76b30;
  color: #fff;
  text-decoration: none;
  white-space: nowrap;
}

@media (max-width: 980px) {
  .contact-layout,
  .prepare-grid {
    grid-template-columns: 1fr;
  }

  .page-hero h1 {
    font-size: 34px;
  }

  .cta-inner {
    flex-direction: column;
    align-items: flex-start;
  }
}

@media (max-width: 640px) {
  .page-hero-content,
  .section-inner {
    width: min(100% - 28px, 1180px);
  }

  .page-hero {
    min-height: auto;
    padding: 70px 0;
  }

  .page-hero h1 {
    font-size: 28px;
  }

  .section {
    padding: 52px 0;
  }

  .contact-form {
    padding: 22px 16px;
  }

  .contact-form ::v-deep .el-form-item__label {
    float: none;
    display: block;
    text-align: left;
    width: auto !important;
    padding: 0 0 8px;
  }

  .contact-form ::v-deep .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>
